const SvgIconJoy = (props) => (
  <svg viewBox="0 0 23 23" {...props}>
    <g fill="currentColor">
      <path d="M16.334 14.127a.5.5 0 0 0-.707.04A5.539 5.539 0 0 1 11.5 16a5.54 5.54 0 0 1-4.128-1.834.5.5 0 1 0-.744.668A6.541 6.541 0 0 0 11.5 17c1.864 0 3.64-.79 4.872-2.166a.5.5 0 0 0-.038-.707z" />
      <path d="M11.5 0C5.159 0 0 5.159 0 11.5S5.159 23 11.5 23 23 17.841 23 11.5 17.841 0 11.5 0zm0 22C5.71 22 1 17.29 1 11.5S5.71 1 11.5 1 22 5.71 22 11.5 17.29 22 11.5 22z" />
      <path d="M15.5 8a2.503 2.503 0 0 0-2.5 2.5.5.5 0 0 0 1 0c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5a.5.5 0 0 0 1 0C18 9.121 16.878 8 15.5 8zM9 10.5a.5.5 0 0 0 1 0C10 9.121 8.879 8 7.5 8A2.503 2.503 0 0 0 5 10.5a.5.5 0 0 0 1 0C6 9.673 6.673 9 7.5 9S9 9.673 9 10.5z" />
    </g>
  </svg>
)

export default SvgIconJoy
